import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { faces_form_connected_component } from '../../lattice';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import { img } from '@phi/components';
import circular_svg from '../../../assets/img/SVG_icons/Top/editing_model/make_circular.svg';
import { uid_make_circular_selected_edges_or_face } from '@frontend/circularity';
import CircularTooltip from './CircularTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const CircularIcon = circular_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Circular';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || !(
                    this.state.selected_edges_count > 0
                    || this.state.selected_faces_count === 1
                    || (
                        this.state.selected_faces_count > 1
                        && faces_form_connected_component(uid_selected_faces.keys())
                    )
                );
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_make_circular_selected_edges_or_face(false);
        },
    },

    render() {
        return h(BarButton, {
            id: 'make-circular-button',
            wrapperId: 'make-circular-wrapper',
            tippy: 'left',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 7,
            help: 'make_circular',
        }, {
            label: () => 'Circular',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(circular_svg, this.alt),
            tooltip: CircularTooltip,
        });
    },
});
